import React from 'react';

import styles from 'src/icons/RentManager.module.css';
import rentmanagerIcon from 'src/assets/img/rentmanager-icon.png';

type Props = {
    size?: number;
    className?: string;
};

export default function RentManager({ size = 24, className }: Props) {
    return (
        <img
            src={rentmanagerIcon}
            alt="RentManager"
            width={size}
            height={size}
            className={className ? `${styles.icon} ${className}` : styles.icon}
        />
    );
}
